export default class Basket {
    constructor(element) {
      this.el = element
      this.outerbasket = document.querySelector(".outer-basket")
      this.innerbasket = this.el.querySelector(".basket-inner")
   
      this.init()
    }
  
    init() {
     	
	var controller = new ScrollMagic.Controller()

	// build a scene
	var slidein = new ScrollMagic.Scene({
    triggerElement: '.the-basket',
    offset: '1200',
    reverse: true
	})
    .setClassToggle('.basket-inner', 'stickybasket') // add class to project01
    

  .addTo(controller)
  
  
  
 
  this.outerbasket.style.height = this.innerbasket.offsetHeight + "px";
    

  
}
    
}
   
  